import React from 'react';
import ComingSoon from '../ComingSoon';

const Logic = () => {
    return (
        <ComingSoon 
            title="🧠 Logic"
            description="Boolesche Logik und Wahrheitstabellen"
            icon="⚙️"
            features={[
                "Wahrheitstabellen Rechner (AND, OR, NOT, XOR, NAND, NOR)",
                "Boolesche Ausdrücke evaluieren",
                "Logikgatter Simulator",
                "Ausdrucks-Vereinfachung (Algebraische Umformungen)",
                "Binary/Boolean Converter",
                "Step-by-Step Lösungserklärung"
            ]}
        />
    );
};

export default Logic;